import { z } from 'zod';
import { NewsDivision } from './news.model';

export interface CreateNewsRequest {
  title: string;
  htmlContent: string;
  division: NewsDivision;
  displayDate: string;
}

export const CreateNewsRequestSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  htmlContent: z.string().min(1, 'HTML content is required'),
  division: z.enum([NewsDivision.CCL, NewsDivision.TSF, NewsDivision.Company]),
  displayDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD'),
});
